import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { FragranceService } from '~/service/service.fragrance';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';
import { Text } from '../view.box';

export const FragrancesImpressionsDialog = observer(() => {
	const [fragrances, ui] = useService(FragranceService, UIService);

	const handleConfirm = useCallback(async () => {
		ui.hideDialog();
		fragrances.recalculateImpressions();
	}, [fragrances, ui]);

	return (
		<Dialog open={ui.dialog === FragrancesImpressionsDialog} onClose={ui.hideDialog} maxWidth="md">
			<DialogTitle>Recalculate Fragrance Impressions</DialogTitle>
			<DialogContent>
				<Text>
					This action will recalculate fragrance characteristics (sillage, longevity, concentration, seasons,
					occasions, and weather) based on all user experiences and reviews.
				</Text>
				<br />
				<Text color="error.main" fontWeight="bold">
					Depending on the number of users and fragrances, this may take some time.
				</Text>
				<Text color="error.main" fontWeight="bold">
					Are you sure you want to proceed?
				</Text>
			</DialogContent>
			<DialogActions>
				<Button onClick={ui.hideDialog}>Cancel</Button>
				<Button color="primary" variant="contained" onClick={handleConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
});
